export const clearLoginInfo = () => {
    localStorage.removeItem("doctoraU")
}